/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_HeInputs */

const en_lang_he = /** @type {(inputs: Lang_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const he_lang_he = /** @type {(inputs: Lang_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

/**
* | output |
* | --- |
* | "עברית" |
*
* @param {Lang_HeInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lang_he = /** @type {((inputs?: Lang_HeInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_HeInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lang_he(inputs)
	return he_lang_he(inputs)
});